import Components from "../../components";
import settings from './settings'
const Categories = ({ data,dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Kategoriler"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.MenuList id="menu-list" label="Menu List" extendedSettings={settings} />
    </div>
  );
};

export default Categories;
